import { MedigapPlan } from "../../utils/plans";

const plans: { [index: string]: MedigapPlan[] } = {
  MA: [
    {
      state: "MA",
      plan_type: "MEDIGAP_PLAN_TYPE_MA_CORE",
      plan_details_name: "medigap.ma_core.plan_details_name",
      plan_policy_name: "medigap.ma_core.plan_policy_name",
      part_a_deductible: "$1,408",
      part_b_deductible: "$198",
      part_b_coinsurance: "$0",
      plan_benefits: "",
      hospital_stay_1_60: "medigap.ma_core.hospital_stay_1_60",
      hospital_stay_61_90: "$0",
      hospital_stay_91_150: "medigap.ma_core.hospital_stay_91_150",
      hospital_stay_additional_365:
        "medigap.ma_core.hospital_stay_additional_365",
      hospital_stay_after_365: "medigap.ma_core.hospital_stay_after_365",
      snf_days_1_20: "$0",
      snf_days_21_100: "medigap.ma_core.snf_days_21_100",
      snf_after_100_days: "medigap.ma_core.hospital_stay_after_365",
      a_blood_first_3: "$0",
      a_blood_after_3: "$0",
      hospice: "$0",
      ip_mental_bio_days_1_60: "medigap.ma_core.hospital_stay_1_60",
      ip_mental_bio_days_61_90: "$0",
      ip_mental_bio_days_91_190: "medigap.ma_core.hospital_stay_91_150",
      ip_mental_bio_add_365_days: "$0",
      ip_mental_bio_beyond_add_365_days:
        "medigap.ma_core.hospital_stay_after_365",
      ip_mental_other_first_60: "medigap.ma_core.ip_mental_other_first_60",
      ip_mental_other_61: "$0",
      ip_mental_other_after_60_cy: "medigap.ma_core.hospital_stay_after_365",
      home_health: "$0",
      dme_first: "medigap.ma_core.dme_first",
      dme_remainder_then: "$0",
      covered_medical_services_first: "medigap.ma_core.dme_first",
      covered_medical_services_then: "$0",
      preventive_services: "medigap.ma_core.preventive_services",
      excess_charges: "medigap.ma_core.hospital_stay_after_365",
      b_blood_first_3: "$0",
      b_blood_after_3: "medigap.ma_core.b_blood_after_3",
      tests_diagnostics: "$0",
      outpatient_biological_mental_covered_first: "medigap.ma_core.dme_first",
      outpatient_biological_mental_covered_then: "$0",
      outpatient_biological_mental_not_covered: "$0",
      outpatient_other_mental_covered_first: "medigap.ma_core.dme_first",
      outpatient_other_mental_covered_then: "$0",
      outpatient_other_mental_not_covered_1_24_visits: "$0",
      outpatient_other_mental_not_covered_25_plus_visits:
        "medigap.ma_core.hospital_stay_after_365",
      state_mandate_covered_first: "medigap.ma_core.dme_first",
      state_mandate_covered_then: "$0",
      state_mandate_not_covered: "medigap.ma_core.state_mandate_not_covered",
      foreign_travel_emergency: "medigap.ma_core.hospital_stay_after_365",
      plan_name: "medigap.ma.ma_core.name",
      part_b_coinsurance_note: "medigap.a.part_b_coinsurance",
    },
    {
      state: "MA",
      plan_type: "MEDIGAP_PLAN_TYPE_MA_SUPP_1",
      plan_details_name: "medigap.ma_supp_1.plan_details_name",
      plan_policy_name: "medigap.ma_supp_1.plan_policy_name",
      part_a_deductible: "$0",
      part_b_deductible: "$0",
      part_b_coinsurance: "$0",
      plan_benefits: "1,2,3,4,5",
      hospital_stay_1_60: "$0",
      hospital_stay_61_90: "$0",
      hospital_stay_91_150: "medigap.ma_core.hospital_stay_91_150",
      hospital_stay_additional_365:
        "medigap.ma_core.hospital_stay_additional_365",
      hospital_stay_after_365: "medigap.ma_core.hospital_stay_after_365",
      snf_days_1_20: "$0",
      snf_days_21_100: "$0",
      snf_days_101_365: "medigap.ma_supp_1.snf_days_101_365",
      snf_days_after_365: "medigap.ma_core.hospital_stay_after_365",
      snf_not_covered_1_365: "medigap.ma_supp_1.snf_days_101_365",
      snf_not_covered_after_365_days: "medigap.ma_core.hospital_stay_after_365",
      a_blood_first_3: "$0",
      a_blood_after_3: "$0",
      hospice: "$0",
      ip_mental_bio_days_1_60: "$0",
      ip_mental_bio_days_61_90: "$0",
      ip_mental_bio_days_91_190: "medigap.ma_core.hospital_stay_91_150",
      ip_mental_bio_add_365_days: "$0",
      ip_mental_bio_beyond_add_365_days:
        "medigap.ma_core.hospital_stay_after_365",
      ip_mental_other_first_60: "$0",
      ip_mental_other_61: "$0",
      ip_mental_other_after_60_cy: "medigap.ma_core.hospital_stay_after_365",
      home_health: "$0",
      dme_first: "$0",
      dme_remainder_then: "$0",
      covered_medical_services_first: "$0",
      covered_medical_services_then: "$0",
      preventive_services: "medigap.ma_core.preventive_services",
      excess_charges: "medigap.ma_core.hospital_stay_after_365",
      b_blood_first_3: "$0",
      b_blood_after_3: "$0",
      tests_diagnostics: "$0",
      outpatient_biological_mental_covered_first: "$0",
      outpatient_biological_mental_covered_then: "$0",
      outpatient_biological_mental_not_covered: "$0",
      outpatient_other_mental_covered_first: "$0",
      outpatient_other_mental_covered_then: "$0",
      outpatient_other_mental_not_covered_1_24_visits: "$0",
      outpatient_other_mental_not_covered_25_plus_visits:
        "medigap.ma_core.hospital_stay_after_365",
      state_mandate_covered_first: "$0",
      state_mandate_covered_then: "$0",
      state_mandate_not_covered: "medigap.ma_core.state_mandate_not_covered",
      foreign_travel_emergency: "$0",
      plan_name: "medigap.ma.ma_supp_1.name",
      part_b_coinsurance_note: "medigap.a.part_b_coinsurance",
    },
    {
      state: "MA",
      plan_type: "MEDIGAP_PLAN_TYPE_MA_SUPP_1A",
      plan_details_name: "medigap.ma_supp_1a.plan_details_name",
      plan_policy_name: "medigap.ma_supp_1a.plan_policy_name",
      part_a_deductible: "$0",
      part_b_deductible: "$198",
      part_b_coinsurance: "$0",
      plan_benefits: "1,2,4,5",
      hospital_stay_1_60: "$0",
      hospital_stay_61_90: "$0",
      hospital_stay_91_150: "medigap.ma_core.hospital_stay_91_150",
      hospital_stay_additional_365:
        "medigap.ma_core.hospital_stay_additional_365",
      hospital_stay_after_365: "medigap.ma_core.hospital_stay_after_365",
      snf_days_1_20: "$0",
      snf_days_21_100: "$0",
      snf_days_101_365: "medigap.ma_supp_1.snf_days_101_365",
      snf_days_after_365: "medigap.ma_core.hospital_stay_after_365",
      snf_not_covered_1_365: "medigap.ma_supp_1.snf_days_101_365",
      snf_not_covered_after_365_days: "medigap.ma_core.hospital_stay_after_365",
      a_blood_first_3: "$0",
      a_blood_after_3: "$0",
      hospice: "$0",
      ip_mental_bio_days_1_60: "$0",
      ip_mental_bio_days_61_90: "$0",
      ip_mental_bio_days_91_190: "medigap.ma_core.hospital_stay_91_150",
      ip_mental_bio_add_365_days: "$0",
      ip_mental_bio_beyond_add_365_days:
        "medigap.ma_core.hospital_stay_after_365",
      ip_mental_other_first_60: "$0",
      ip_mental_other_61: "$0",
      ip_mental_other_after_60_cy: "medigap.ma_core.hospital_stay_after_365",
      home_health: "$0",
      dme_first: "medigap.ma_core.dme_first",
      dme_remainder_then: "$0",
      covered_medical_services_first: "medigap.ma_core.dme_first",
      covered_medical_services_then: "$0",
      preventive_services: "medigap.ma_core.preventive_services",
      excess_charges: "medigap.ma_core.hospital_stay_after_365",
      b_blood_first_3: "$0",
      b_blood_after_3: "medigap.ma_core.b_blood_after_3",
      tests_diagnostics: "$0",
      outpatient_biological_mental_covered_first: "medigap.ma_core.dme_first",
      outpatient_biological_mental_covered_then: "$0",
      outpatient_biological_mental_not_covered: "$0",
      outpatient_other_mental_covered_first: "medigap.ma_core.dme_first",
      outpatient_other_mental_covered_then: "$0",
      outpatient_other_mental_not_covered_1_24_visits: "$0",
      outpatient_other_mental_not_covered_25_plus_visits:
        "medigap.ma_core.hospital_stay_after_365",
      state_mandate_covered_first: "medigap.ma_core.dme_first",
      state_mandate_covered_then: "$0",
      state_mandate_not_covered: "medigap.ma_core.state_mandate_not_covered",
      foreign_travel_emergency: "$0",
      plan_name: "medigap.ma.ma_supp_1a.name",
      part_b_coinsurance_note: "medigap.a.part_b_coinsurance",
    },
  ],
  MN: [
    {
      state: "MN",
      plan_type: "MEDIGAP_PLAN_TYPE_MN_BASIC",
      plan_details_name: "medigap.mn_basic.plan_details_name",
      plan_policy_name: "medigap.mn_basic.plan_policy_name",
      part_a_deductible: "$1,408",
      part_b_deductible: "$198",
      part_b_coinsurance: "$0",
      plan_benefits: "1,5",
      hospital_stay_1_60: "medigap.ma_core.hospital_stay_1_60",
      hospital_stay_61_90: "$0",
      hospital_stay_91_150: "medigap.ma_core.hospital_stay_91_150",
      hospital_stay_after_150: "medigap.ma_core.hospital_stay_after_365",
      snf_days_1_20: "$0",
      snf_days_21_100: "$0",
      snf_after_100_days: "medigap.ma_core.hospital_stay_after_365",
      a_blood_first_3: "$0",
      a_blood_after_3: "$0",
      hospice: "$0",
      home_health: "$0",
      dme_first: "medigap.ma_core.dme_first",
      dme_remainder_then: "$0",
      covered_medical_services_first: "medigap.ma_core.dme_first",
      covered_medical_services_then: "$0",
      prev_serv_cover: "medigap.mn_basic.prev_serv_cover",
      prev_serv_non: "medigap.mn_basic.prev_serv_non",
      excess_charges: "medigap.ma_core.hospital_stay_after_365",
      b_blood_first_3: "$0",
      b_blood_after_3: "medigap.ma_core.b_blood_after_3",
      tests_diagnostics: "$0",
      phys_ther: "$0",
      op_mental_health: "$0",
      foreign_travel_emergency: "medigap.mn_basic.foreign_travel_emergency",
      state_mand: "medigap.mn_basic.state_mand",
      plan_name: "medigap.mn.mn_basic.name",
      part_b_coinsurance_note: "medigap.a.part_b_coinsurance",
    },
    {
      state: "MN",
      plan_type: "MEDIGAP_PLAN_TYPE_MN_EXT_BASIC",
      plan_details_name: "medigap.mn_ext_basic.plan_details_name",
      plan_policy_name: "medigap.mn_ext_basic.plan_policy_name",
      part_a_deductible: "$0",
      part_b_deductible: "$0",
      part_b_coinsurance: "$0",
      plan_benefits: "1,2,3,4,5",
      hospital_stay_1_60: "$0",
      hospital_stay_61_90: "$0",
      hospital_stay_91_150: "medigap.ma_core.hospital_stay_91_150",
      hospital_stay_after_150: "medigap.ma_core.hospital_stay_after_365",
      snf_days_1_20: "$0",
      snf_days_21_120: "$0",
      snf_after_120_days: "medigap.ma_core.hospital_stay_after_365",
      a_blood_first_3: "$0",
      a_blood_after_3: "$0",
      hospice: "$0",
      home_health: "$0",
      dme_first: "$0",
      dme_remainder_then: "$0",
      covered_medical_services_first: "$0",
      covered_medical_services_then: "$0",
      prev_serv_cover: "medigap.mn_basic.prev_serv_cover",
      prev_serv_non: "medigap.mn_ext_basic.prev_serv_non",
      excess_charges: "$0",
      b_blood_first_3: "$0",
      b_blood_after_3: "$0",
      tests_diagnostics: "$0",
      phys_ther: "$0",
      op_mental_health: "$0",
      foreign_travel_emergency: "medigap.mn_basic.foreign_travel_emergency",
      state_mand: "medigap.mn_ext_basic.state_mand",
      plan_name: "medigap.mn.mn_ext_basic.name",
      part_b_coinsurance_note: "medigap.a.part_b_coinsurance",
    },
    {
      state: "MN",
      plan_type: "MEDIGAP_PLAN_TYPE_MN_EXT_BASIC_NEW",
      plan_details_name: "medigap.mn_ext_basic_new.plan_details_name",
      plan_policy_name: "medigap.mn_ext_basic_new.plan_policy_name",
      part_a_deductible: "$0",
      part_b_deductible: "$198",
      part_b_coinsurance: "$0",
      plan_benefits: "1,2,4,5",
      hospital_stay_1_60: "$0",
      hospital_stay_61_90: "$0",
      hospital_stay_91_150: "medigap.ma_core.hospital_stay_91_150",
      hospital_stay_after_150: "medigap.ma_core.hospital_stay_after_365",
      snf_days_1_20: "$0",
      snf_days_21_120: "$0",
      snf_after_120_days: "medigap.ma_core.hospital_stay_after_365",
      a_blood_first_3: "$0",
      a_blood_after_3: "$0",
      hospice: "$0",
      home_health: "$0",
      dme_first: "medigap.ma_core.dme_first",
      dme_remainder_then: "$0",
      covered_medical_services_first: "medigap.ma_core.dme_first",
      covered_medical_services_then: "$0",
      prev_serv_cover: "medigap.mn_basic.prev_serv_cover",
      prev_serv_non: "medigap.mn_ext_basic.prev_serv_non",
      excess_charges: "$0",
      b_blood_first_3: "$0",
      b_blood_after_3: "medigap.ma_core.b_blood_after_3",
      tests_diagnostics: "$0",
      phys_ther: "$0",
      op_mental_health: "$0",
      foreign_travel_emergency: "medigap.mn_basic.foreign_travel_emergency",
      state_mand: "medigap.mn_ext_basic.state_mand",
      plan_name: "medigap.mn.mn_ext_basic_no_partb.name",
      part_b_coinsurance_note: "medigap.a.part_b_coinsurance",
    },
    {
      state: "MN",
      plan_type: "MEDIGAP_PLAN_TYPE_MN_HIGH_F",
      plan_details_name: "medigap.mn_high_f.plan_details_name",
      plan_policy_name: "medigap.mn_high_f.plan_policy_name",
      part_a_deductible: "$0",
      part_b_deductible: "$0",
      part_b_coinsurance: "$0",
      plan_benefits: "1,2,3,5",
      hospital_stay_1_60: "$0",
      hospital_stay_61_90: "$0",
      hospital_stay_91_150: "medigap.ma_core.hospital_stay_91_150",
      hospital_stay_after_150: "medigap.ma_core.hospital_stay_after_365",
      snf_days_1_20: "$0",
      snf_days_21_100: "$0",
      snf_after_100_days: "medigap.ma_core.hospital_stay_after_365",
      a_blood_first_3: "$0",
      a_blood_after_3: "$0",
      hospice: "$0",
      home_health: "$0",
      dme_first: "$0",
      dme_remainder_then: "$0",
      covered_medical_services_first: "$0",
      covered_medical_services_then: "$0",
      prev_serv_cover: "medigap.mn_basic.prev_serv_cover",
      prev_serv_non: "medigap.mn_ext_basic.prev_serv_non",
      excess_charges: "medigap.ma_core.hospital_stay_after_365",
      b_blood_first_3: "$0",
      b_blood_after_3: "$0",
      tests_diagnostics: "$0",
      phys_ther: "$0",
      op_mental_health: "$0",
      foreign_travel_emergency: "$0",
      state_mand: "medigap.mn_basic.state_mand",
      plan_name: "medigap.mn.mn_high_f.name",
      part_b_coinsurance_note: "medigap.mn.high_f.part_b_coinsurance",
      total_deductible: "$2,340",
    },
    {
      state: "MN",
      plan_type: "MEDIGAP_PLAN_TYPE_MN_HIGH_F_NEW",
      plan_details_name: "medigap.mn_high_f_new.plan_details_name",
      plan_policy_name: "medigap.mn_high_f_new.plan_policy_name",
      part_a_deductible: "$0",
      part_b_deductible: "$198",
      part_b_coinsurance: "$0",
      plan_benefits: "1,2,5",
      hospital_stay_1_60: "$0",
      hospital_stay_61_90: "$0",
      hospital_stay_91_150: "medigap.ma_core.hospital_stay_91_150",
      hospital_stay_after_150: "medigap.ma_core.hospital_stay_after_365",
      snf_days_1_20: "$0",
      snf_days_21_100: "$0",
      snf_after_100_days: "medigap.ma_core.hospital_stay_after_365",
      a_blood_first_3: "$0",
      a_blood_after_3: "$0",
      hospice: "$0",
      home_health: "$0",
      dme_first: "medigap.ma_core.dme_first",
      dme_remainder_then: "$0",
      covered_medical_services_first: "medigap.ma_core.dme_first",
      covered_medical_services_then: "$0",
      prev_serv_cover: "medigap.mn_basic.prev_serv_cover",
      prev_serv_non: "medigap.mn_ext_basic.prev_serv_non",
      excess_charges: "medigap.ma_core.hospital_stay_after_365",
      b_blood_first_3: "$0",
      b_blood_after_3: "medigap.ma_core.b_blood_after_3",
      tests_diagnostics: "$0",
      phys_ther: "$0",
      op_mental_health: "$0",
      foreign_travel_emergency: "$0",
      state_mand: "medigap.mn_basic.state_mand",
      plan_name: "medigap.mn.mn_high_f_new.name",
      part_b_coinsurance_note: "medigap.mn.high_f.part_b_coinsurance",
      total_deductible: "$2,340",
    },
    {
      state: "MN",
      plan_type: "MEDIGAP_PLAN_TYPE_MN_SUPP_50",
      plan_details_name: "medigap.mn_supp_50.plan_details_name",
      plan_policy_name: "medigap.mn_supp_50.plan_policy_name",
      part_a_deductible: "$704",
      part_b_deductible: "$198",
      part_b_coinsurance: "medigap.mn_supp_50.part_b_coinsurance",
      out_pocket_limit: "medigap.mn_supp_50.out_pocket_limit",
      plan_benefits: "1,2",
      hospital_stay_1_60: "medigap.mn_supp_50.hospital_stay_1_60",
      hospital_stay_61_90: "$0",
      hospital_stay_91_150: "medigap.ma_core.hospital_stay_91_150",
      hospital_stay_additional_365:
        "medigap.ma_core.hospital_stay_additional_365",
      hospital_stay_after_365: "medigap.ma_core.hospital_stay_after_365",
      snf_days_1_20: "$0",
      snf_days_21_100: "medigap.mn_supp_50.snf_days_21_100",
      snf_after_100_days: "medigap.ma_core.hospital_stay_after_365",
      a_blood_first_3: "medigap.mn_supp_50.a_blood_first_3",
      a_blood_after_3: "$0",
      hospice: "medigap.mn_supp_50.hospice",
      home_health: "$0",
      dme_first: "medigap.ma_core.dme_first",
      dme_remainder_then: "medigap.mn_supp_50.dme_remainder_then",
      covered_medical_services_first: "medigap.ma_core.dme_first",
      covered_medical_services_then:
        "medigap.mn_supp_50.covered_medical_services_then",
      preventive_services: "medigap.mn_supp_50.preventive_services",
      excess_charges: "medigap.mn_supp_50.excess_charges",
      b_blood_first_3: "medigap.mn_supp_50.a_blood_first_3",
      b_blood_after_3: "medigap.mn_supp_50.b_blood_after_3",
      foreign_travel_emergency: "medigap.ma_core.hospital_stay_after_365",
      state_mand: "medigap.mn_basic.state_mand",
      plan_name: "medigap.mn.mn_supp_50.name",
      part_a_deductible_note: "medigap.k.part_a_note",
      part_b_coinsurance_note: "medigap.mn.supp_50.part_b_coinsurance",
    },
    {
      state: "MN",
      plan_type: "MEDIGAP_PLAN_TYPE_MN_SUPP_75",
      plan_details_name: "medigap.mn_supp_75.plan_details_name",
      plan_policy_name: "medigap.mn_supp_75.plan_policy_name",
      part_a_deductible: "$352",
      part_b_deductible: "$198",
      part_b_coinsurance: "medigap.mn_supp_75.part_b_coinsurance",
      out_pocket_limit: "medigap.mn_supp_75.out_pocket_limit",
      plan_benefits: "1,2",
      hospital_stay_1_60: "medigap.mn_supp_75.hospital_stay_1_60",
      hospital_stay_61_90: "$0",
      hospital_stay_91_150: "medigap.ma_core.hospital_stay_91_150",
      hospital_stay_additional_365:
        "medigap.ma_core.hospital_stay_additional_365",
      hospital_stay_after_365: "medigap.ma_core.hospital_stay_after_365",
      snf_days_1_20: "$0",
      snf_days_21_100: "medigap.mn_supp_75.snf_days_21_100",
      snf_after_100_days: "medigap.ma_core.hospital_stay_after_365",
      a_blood_first_3: "medigap.mn_supp_75.a_blood_first_3",
      a_blood_after_3: "$0",
      hospice: "medigap.mn_supp_75.hospice",
      home_health: "$0",
      dme_first: "medigap.ma_core.dme_first",
      dme_remainder_then: "medigap.mn_supp_75.dme_remainder_then",
      covered_medical_services_first: "medigap.ma_core.dme_first",
      covered_medical_services_then:
        "medigap.mn_supp_75.covered_medical_services_then",
      preventive_services: "medigap.mn_supp_50.preventive_services",
      excess_charges: "medigap.mn_supp_75.excess_charges",
      b_blood_first_3: "medigap.mn_supp_75.a_blood_first_3",
      b_blood_after_3: "medigap.mn_supp_75.b_blood_after_3",
      foreign_travel_emergency: "medigap.ma_core.hospital_stay_after_365",
      state_mand: "medigap.mn_basic.state_mand",
      plan_name: "medigap.mn.mn_supp_75.name",
      part_a_deductible_note: "medigap.l.part_a_note",
      part_b_coinsurance_note: "medigap.mn.supp_75.part_b_coinsurance",
    },
    {
      state: "MN",
      plan_type: "MEDIGAP_PLAN_TYPE_MN_N",
      plan_details_name: "medigap.mn_n.plan_details_name",
      plan_policy_name: "medigap.mn_n.plan_policy_name",
      part_a_deductible: "$0",
      part_b_deductible: "$198",
      part_b_coinsurance: "$0",
      plan_benefits: "1,2,5",
      hospital_stay_1_60: "$0",
      hospital_stay_61_90: "$0",
      hospital_stay_91_150: "medigap.ma_core.hospital_stay_91_150",
      hospital_stay_additional_365:
        "medigap.ma_core.hospital_stay_additional_365",
      hospital_stay_after_365: "medigap.ma_core.hospital_stay_after_365",
      snf_days_1_20: "$0",
      snf_days_21_100: "$0",
      snf_after_100_days: "medigap.ma_core.hospital_stay_after_365",
      a_blood_first_3: "$0",
      a_blood_after_3: "$0",
      hospice: "$0",
      home_health: "$0",
      dme_first: "medigap.ma_core.dme_first",
      dme_remainder_then: "$0",
      covered_medical_services_first: "medigap.ma_core.dme_first",
      covered_medical_services_then:
        "medigap.mn_n.covered_medical_services_then",
      preventive_services: "medigap.mn_basic.prev_serv_cover",
      excess_charges: "medigap.ma_core.hospital_stay_after_365",
      b_blood_first_3: "$0",
      b_blood_after_3: "medigap.ma_core.b_blood_after_3",
      foreign_travel_emergency_first: "$250",
      foreign_travel_emergency_remainder_then:
        "medigap.mn_n.foreign_travel_emergency_remainder_then",
      state_mand: "medigap.mn_basic.state_mand",
      plan_name: "medigap.mn.mn_n.name",
      part_b_coinsurance_note: "medigap.n.part_b_coinsurance",
    },
    {
      state: "MN",
      plan_type: "MEDIGAP_PLAN_TYPE_MN_M",
      plan_name: "Minnesota Version Plan M",
      plan_details_name: "medigap.mn_m.plan_details_name",
      plan_policy_name: "medigap.mn_m.plan_policy_name",
      part_a_deductible: "$704",
      part_a_deductible_note: "medigap.mn_m.part_a_deductible_note",
      part_b_deductible: "$198",
      part_b_coinsurance: "$0",
      part_b_coinsurance_note: "medigap.mn_m.part_b_coinsurance_note",
      plan_benefits: "1,2,5",
      hospital_stay_1_60: "medigap.mn_supp_50.hospital_stay_1_60",
      hospital_stay_61_90: "$0",
      hospital_stay_91_150: "medigap.ma_core.hospital_stay_91_150",
      hospital_stay_additional_365:
        "medigap.ma_core.hospital_stay_additional_365",
      hospital_stay_after_365: "medigap.ma_core.hospital_stay_after_365",
      snf_days_1_20: "$0",
      snf_days_21_100: "$0",
      snf_after_100_days: "medigap.ma_core.hospital_stay_after_365",
      a_blood_first_3: "$0",
      a_blood_after_3: "$0",
      hospice: "$0",
      home_health: "$0",
      dme_first: "medigap.ma_core.dme_first",
      dme_remainder_then: "$0",
      covered_medical_services_first: "medigap.ma_core.dme_first",
      covered_medical_services_then: "$0",
      preventive_services: "medigap.mn_basic.prev_serv_cover",
      excess_charges: "medigap.ma_core.hospital_stay_after_365",
      b_blood_first_3: "$0",
      b_blood_after_3: "medigap.ma_core.b_blood_after_3",
      tests_diagnostics: "$0",
      foreign_travel_emergency_first: "$250",
      foreign_travel_emergency_remainder_then:
        "medigap.mn_n.foreign_travel_emergency_remainder_then",
      state_mand: "medigap.mn_basic.state_mand",
    },
  ],
  WI: [
    {
      state: "WI",
      plan_type: "MEDIGAP_PLAN_TYPE_WI_BASIC",
      plan_details_name: "medigap.mn_basic.plan_details_name",
      plan_policy_name: "medigap.mn_basic.plan_policy_name",
      part_a_deductible: "$1,408",
      part_b_deductible: "$198",
      part_b_coinsurance: "$0",
      plan_benefits: "1",
      hospital_stay_1_60: "medigap.ma_core.hospital_stay_1_60",
      hospital_stay_61_90: "$0",
      hospital_stay_91_150: "medigap.ma_core.hospital_stay_91_150",
      hospital_stay_after_150: "medigap.ma_core.hospital_stay_after_365",
      snf_days_1_20: "$0",
      snf_days_21_100: "$0",
      snf_after_100_days: "medigap.ma_core.hospital_stay_after_365",
      a_blood_first_3: "$0",
      a_blood_after_3: "$0",
      hospice: "$0",
      ip_mental_health_days_1_60: "medigap.ma_core.hospital_stay_1_60",
      ip_mental_health_days_61_90: "$0",
      ip_mental_health_days_91_150: "medigap.ma_core.hospital_stay_91_150",
      ip_mental_health_days_add_175:
        "medigap.ma_core.hospital_stay_additional_365",
      ip_mental_health_days_after_175:
        "medigap.ma_core.hospital_stay_after_365",
      home_health: "$0",
      home_health_add_40: "$0",
      home_health_after_40: "medigap.ma_core.hospital_stay_after_365",
      dme_first: "medigap.ma_core.dme_first",
      dme_remainder_then: "$0",
      covered_medical_services_first: "medigap.ma_core.dme_first",
      covered_medical_services_then: "$0",
      prev_serv_cover: "medigap.mn_basic.prev_serv_cover",
      prev_serv_non: "medigap.mn_basic.state_mand",
      excess_charges: "medigap.ma_core.hospital_stay_after_365",
      b_blood_first_3: "$0",
      b_blood_after_3: "medigap.ma_core.b_blood_after_3",
      tests_diagnostics: "$0",
      foreign_travel_emergency: "medigap.ma_core.hospital_stay_after_365",
      state_mand: "medigap.mn_basic.state_mand",
      plan_name: "medigap.wi.wi_basic.name",
      part_b_coinsurance_note: "medigap.a.part_b_coinsurance",
    },
    {
      state: "WI",
      plan_type: "MEDIGAP_PLAN_TYPE_WI_HIGH_DEDUCTIBLE",
      plan_details_name: "medigap.mn_high_f.plan_details_name",
      plan_policy_name: "medigap.mn_high_f.plan_policy_name",
      part_a_deductible: "$0",
      part_b_deductible: "$0",
      part_b_deductible_note: "medigap.wi.high_deductible.part_b_note",
      part_b_coinsurance: "$0",
      plan_benefits: "1,2,3,4,5",
      hospital_stay_1_60: "$0",
      hospital_stay_61_90: "$0",
      hospital_stay_91_150: "medigap.ma_core.hospital_stay_91_150",
      hospital_stay_after_150: "medigap.ma_core.hospital_stay_after_365",
      snf_days_1_20: "$0",
      snf_days_21_100: "$0",
      snf_after_100_days: "medigap.ma_core.hospital_stay_after_365",
      snf_not_days_1_30: "$0",
      snf_not_after_30: "medigap.ma_core.hospital_stay_after_365",
      a_blood_first_3: "$0",
      a_blood_after_3: "$0",
      hospice: "$0",
      ip_mental_health_days_1_60: "$0",
      ip_mental_health_days_61_90: "$0",
      ip_mental_health_days_91_150: "medigap.ma_core.hospital_stay_91_150",
      ip_mental_health_days_add_175:
        "medigap.ma_core.hospital_stay_additional_365",
      ip_mental_health_days_after_175:
        "medigap.ma_core.hospital_stay_after_365",
      home_health: "$0",
      home_health_add_365: "$0",
      home_health_after_365: "medigap.ma_core.hospital_stay_after_365",
      dme_first: "medigap.wi_high_deductible.dme_first",
      dme_remainder_then: "$0",
      covered_medical_services_first: "medigap.wi_high_deductible.dme_first",
      covered_medical_services_then: "$0",
      prev_serv_cover: "medigap.mn_basic.prev_serv_cover",
      prev_serv_non: "medigap.mn_basic.state_mand",
      excess_charges: "$0",
      b_blood_first_3: "$0",
      b_blood_after_3: "medigap.wi_high_deductible.b_blood_after_3",
      tests_diagnostics: "$0",
      foreign_travel_emergency_first: "$250",
      foreign_travel_emergency_remainder_then:
        "medigap.mn_n.foreign_travel_emergency_remainder_then",
      state_mand: "medigap.mn_basic.state_mand",
      plan_name: "medigap.wi.w_high_deductible.name",
      part_b_coinsurance_note: "medigap.a.part_b_coinsurance",
      total_deductible: "$2,240",
    },
    {
      state: "WI",
      plan_type: "MEDIGAP_PLAN_TYPE_WI_25_COST",
      plan_details_name: "medigap.wi_25_cost.plan_details_name",
      plan_policy_name: "medigap.wi_25_cost.plan_policy_name",
      part_a_deductible: "$352",
      part_b_deductible: "$198",
      part_b_coinsurance: "medigap.mn_supp_75.part_b_coinsurance",
      out_pocket_limit: "medigap.mn_supp_75.out_pocket_limit",
      plan_benefits: "1,2",
      hospital_stay_1_60: "medigap.mn_supp_75.hospital_stay_1_60",
      hospital_stay_61_90: "$0",
      hospital_stay_91_150: "medigap.ma_core.hospital_stay_91_150",
      hospital_stay_after_150: "medigap.ma_core.hospital_stay_after_365",
      snf_days_1_20: "$0",
      snf_days_21_100: "medigap.mn_supp_75.snf_days_21_100",
      snf_after_100_days: "medigap.ma_core.hospital_stay_after_365",
      snf_not_days_1_30: "$0",
      snf_not_after_30: "medigap.ma_core.hospital_stay_after_365",
      a_blood_first_3: "medigap.mn_supp_75.a_blood_first_3",
      a_blood_after_3: "$0",
      hospice: "medigap.mn_supp_75.hospice",
      ip_mental_health_days_1_60: "medigap.mn_supp_75.hospital_stay_1_60",
      ip_mental_health_days_61_90: "$0",
      ip_mental_health_days_91_150: "medigap.ma_core.hospital_stay_91_150",
      ip_mental_health_days_add_175:
        "medigap.ma_core.hospital_stay_additional_365",
      ip_mental_health_days_after_175:
        "medigap.ma_core.hospital_stay_after_365",
      home_health: "$0",
      home_health_add_40: "$0",
      home_health_after_40: "medigap.ma_core.hospital_stay_after_365",
      dme_first: "medigap.ma_core.dme_first",
      dme_remainder_then: "medigap.mn_supp_75.dme_remainder_then",
      covered_medical_services_first: "medigap.ma_core.dme_first",
      covered_medical_services_then:
        "medigap.mn_supp_75.covered_medical_services_then",
      prev_serv_cover: "medigap.mn_basic.prev_serv_cover",
      prev_serv_non: "medigap.mn_basic.state_mand",
      excess_charges: "medigap.mn_supp_75.excess_charges",
      b_blood_first_3: "medigap.mn_supp_75.a_blood_first_3",
      b_blood_after_3: "medigap.mn_supp_75.b_blood_after_3",
      tests_diagnostics: "$0",
      foreign_travel_emergency: "medigap.ma_core.hospital_stay_after_365",
      state_mand: "medigap.mn_basic.state_mand",
      plan_name: "medigap.wi.wi_25_cost.name",
      part_a_deductible_note: "medigap.l.part_a_note",
      part_b_coinsurance_note: "medigap.wi.25_cost.part_b_coinsurance",
    },
    {
      state: "WI",
      plan_type: "MEDIGAP_PLAN_TYPE_WI_50_COST",
      plan_details_name: "medigap.mn_supp_50.plan_details_name",
      plan_policy_name: "medigap.mn_supp_50.plan_policy_name",
      part_a_deductible: "$704",
      part_b_deductible: "$198",
      part_b_coinsurance: "medigap.mn_supp_50.part_b_coinsurance",
      out_pocket_limit: "medigap.mn_supp_50.out_pocket_limit",
      plan_benefits: "1,2",
      hospital_stay_1_60: "medigap.mn_supp_50.hospital_stay_1_60",
      hospital_stay_61_90: "$0",
      hospital_stay_91_150: "medigap.ma_core.hospital_stay_91_150",
      hospital_stay_after_150: "medigap.ma_core.hospital_stay_after_365",
      snf_days_1_20: "$0",
      snf_days_21_100: "medigap.mn_supp_50.snf_days_21_100",
      snf_after_100_days: "medigap.ma_core.hospital_stay_after_365",
      snf_not_days_1_30: "$0",
      snf_not_after_30: "medigap.ma_core.hospital_stay_after_365",
      a_blood_first_3: "medigap.mn_supp_50.a_blood_first_3",
      a_blood_after_3: "$0",
      hospice: "medigap.mn_supp_50.hospice",
      ip_mental_health_days_1_60: "medigap.mn_supp_50.hospital_stay_1_60",
      ip_mental_health_days_61_90: "$0",
      ip_mental_health_days_91_150: "medigap.ma_core.hospital_stay_91_150",
      ip_mental_health_days_add_175:
        "medigap.ma_core.hospital_stay_additional_365",
      ip_mental_health_days_after_175:
        "medigap.ma_core.hospital_stay_after_365",
      home_health: "$0",
      home_health_add_40: "$0",
      home_health_after_40: "medigap.ma_core.hospital_stay_after_365",
      dme_first: "medigap.ma_core.dme_first",
      dme_remainder_then: "medigap.mn_supp_50.dme_remainder_then",
      covered_medical_services_first: "medigap.ma_core.dme_first",
      covered_medical_services_then:
        "medigap.mn_supp_50.covered_medical_services_then",
      prev_serv_cover: "medigap.mn_supp_50.preventive_services",
      prev_serv_non: "medigap.mn_basic.state_mand",
      excess_charges: "medigap.mn_supp_50.excess_charges",
      b_blood_first_3: "medigap.mn_supp_50.a_blood_first_3",
      b_blood_after_3: "medigap.mn_supp_50.b_blood_after_3",
      tests_diagnostics: "$0",
      foreign_travel_emergency: "medigap.ma_core.hospital_stay_after_365",
      state_mand: "medigap.mn_basic.state_mand",
      plan_name: "medigap.wi.wi_50_cost.name",
      part_a_deductible_note: "medigap.k.part_a_note",
      part_b_coinsurance_note: "medigap.wi.50_cost.part_b_coinsurance",
    },
  ],
};

export default plans;
